import { render } from "./AllExerciseSheetQuestions.vue?vue&type=template&id=d2a6be60"
import script from "./AllExerciseSheetQuestions.vue?vue&type=script&lang=js"
export * from "./AllExerciseSheetQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__